import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { PaymentType } from '@domgen/dgx-fe-common';
import { FormControlValidators } from '@domgen/dgx-fe-forms/shared';
import { TranslateService } from '@domgen/dgx-fe-i18n';
import {
  FeaturePaymentMethodTranslationDictionary,
  PaymentMethodForm,
  PaymentMethodFormField,
} from '@checkout/util-models';

@Injectable()
export class PaymentMethodFormBuilderService {
  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly translateService: TranslateService<FeaturePaymentMethodTranslationDictionary>
  ) {}

  build(): FormGroup<PaymentMethodForm> {
    const formGroup: PaymentMethodForm = {
      [PaymentMethodFormField.PaymentType]: new FormControl(
        PaymentType.DirectDebit,
        {
          nonNullable: true,
          validators: FormControlValidators.required(
            this.translateService.translate('PAYMENT_METHOD_ERROR_REQUIRED')
          ),
        }
      ),
    };
    return this.formBuilder.group(formGroup);
  }
}
